// extracted by mini-css-extract-plugin
export default {"container":"Artists_container__YyDzw"};